





import Vue from 'vue'

export default Vue.extend({
  name: 'ArrayCellRenderer',

  computed: {
    getList (): string[] {
      // @ts-ignore
      if(this.params.data.competence) {
        // @ts-ignore
        return this.params.data.competence
      }
      return []
    }
  }
})
